export const SignatureListContainer = {
  "refresh": "Refresh",
  "tipContent": "Choose a signature style for self-signing.",
  "signatureListPopup": {
    "title": "Signature List",
    "preferencesBtn": "Preferences",
    "createSignatureBtn": "Create Signature"
  },
  "createSignatureStyle": {
    "title": "Create Signature",
    "editTitle": "Edit Signature",
    "Ok": "OK",
    "Cancel": "Cancel",
    "OptionsBtn": "Options",
    "StyleTypes": {
      "type": "Type",
      "draw": "Draw",
      "import": "Import",
      "paste": "Paste",
      "online": "Online"
    },
    "changeStyle": "Change Style",
    "fullName": "<span class='required'>*</span>Full Name",
    "initials": "Initials",
    "signature": "<span class='required'>*</span>Signature",
    "noFullNameTip": "Please type your full name",
    "noInitialsTip": "Please type your initials",
    "noSignatureTip": "Please type your signature",
    "clear": "Clear",
    "drawSignature": "Draw Signature",
    "drawInitials": "Draw Initials",
    "replace": "Replace",
    "uploadSignature": "Upload Signature",
    "uploadInitials": "Upload Initials",
    "paste": "Paste",
    "snapshotSignature": "Snapshot a signature and paste",
    "snapshotInitial": "Snapshot an initial and paste",
    "noClipboardReadPermissionTip": "You don't have access to read clipboard.",
    "BrowserNotSupport": "Your browser not support reading clipboard data.",
    "SecureContext": "Access clipboard data requires a secure origin, either HTTPS or localhost.",
    "NoDataAtClipboard": "No valid data on clipboard.",
    "noImageInClipboardTip": "The Clipboard is empty.",
    "downloadSignature": "Download Signature",
    "downloadInitials": "Download Initials",
    "invalidImageTip": "This is an unsupported file format."
  },
  "changeStyles": {
    "title": "Change Style",
    "contentTitle": "All Signatures and Initials",
    "contentTitleFillSign": "All Signatures",
    "Ok": "OK",
    "Cancel": "Cancel"
  },
  "optionsDialog": {
    "title": "Options",
    "Ok": "OK",
    "Cancel": "Cancel",
    "convertSignatureToBlackWhite": "Convert signature to black & white",
    "keepOriginalSize": "Keep original size",
    "discardCloses": "Discard this signature when program closes",
    "requirePassword": "Require password to use this signature",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "passwordErrorInfo": "Please make sure that the passwords match and are not empty.",
    "needApplyESign": "The eSign signature process has already started, please complete it before using this feature.",
    "needApplyFillSignTitle": "Signatures Not Applied",
    "needApplyFillSign": "There are signatures that have not been applied. What do you want to do with them?",
    "hasNotSignedSign": "There are signatures that have not been applied.",
    "noFullNameSign": "The signature cannot be applied without placing a full name signature.",
    "noPermissionTip": "The signature is not supported in the signed document.",
    "signedNoRequestSign": "Request failed. The document has been protected or signed by digital Signature/legally-binding electronic signature and couldn't be sent to others for signature.",
    "requestSignHasUnApplyEsign": "If you want to request signature, please remove the unapplied signature first.",
    "requestSignNeedSave": "The PDF document must be saved before operation. Please save the document and try again.",
    "oneESignTypeOnly": "Foxit eSign only supports signing a set of signatures (including full name and initials) at a time.",
    "signUpdateApplyTip": "The default signature style has been changed, it is suggested to apply the existing signatures on your PDF before placing a new signature in new signature style. Do you want to apply the existing signatures?",
    "notSupportFillSign": "Ink signature is not supported in the signed document.",
    "applyAll": "Apply All",
    "discard": "Discard",
    "applyFillSign": "Apply Ink Sign",
    "applyESign": "Apply Foxit eSign",
    "no": "No",
    "yes": "Yes",
    "placeMoreTitle": "Place on Multiple Pages",
    "pageRange": "Page Range",
    "allPage": "All pages",
    "from": "From",
    "to": "To",
    "oddAndEven": "Odd and Even Pages",
    "odd": "Odd Pages",
    "even": "Even Pages"
  },
  "manageSignaturesDialog": {
    "title": "Manage Signatures",
    "close": "Close",
    "Ok": "OK",
    "fullName": "Full Name",
    "initials": "Initials",
    "add": "+ Add",
    "createSignature": "Create Signature",
    "editTip": "Edit",
    "deleteTip": "Delete",
    "saveOnlineTip": "Save Online",
    "uploadTipTitle": "Upload signatures",
    "uploadTipInfo": "Upload the signature to the eSign server to obtain legal binding. Only one signature can be uploaded at the same time.",
    "foxitESignSignatureInUseSignatureTip": "This signature style is in use, please try it later.",
    "uploadSignatureSuccess": "Upload signature to cloud successfully.",
    "uploadSignatureFailed": "Failed to upload signature to cloud, please try again."
  },
  "deleteConfirmDialog": {
    "title": "Delete Signature",
    "Ok": "Yes",
    "Cancel": "No",
    "info": "Do you want to remove the signature?",
    "removeSignatureLabel": "Also remove the cloud signature"
  },
  "onlineSignatureDialog": {
    "title": "Online Signature",
    "Delete": "Delete",
    "Download": "Download",
    "Cancel": "Cancel",
    "noOnlineSignaturesTip": "No Online signature has been saved yet."
  },
  "passwordDialog": {
    "title": "Password",
    "Ok": "Ok",
    "Cancel": "Cancel",
    "tipContent": "Usage of signature profile is protected and cannot be applied without providing the correct password.",
    "passwordLabel": "Open Password",
    "errorTip": "Incorrect password, please check the password and try again."
  }
}